<div class="flex flex-col">
    <form class="lg:max-w-lg" (ngSubmit)="onSearch()" autocomplete="off" action="">
        <div class="control-box mb-0">
            <label for="search">{{ label }} <span *ngIf="required" class="text-red-600">*</span></label>
            <div class="control-container">
                <input class="control control-icon" type="text" name="search" [placeholder]="placeholder" [(ngModel)]="search" (input)="onKeyPress()" [disabled]="selected">
                <i *ngIf="!selected" class="fa-solid fa-magnifying-glass icon"></i>
                <i *ngIf="selected" class="fa-solid fa-circle-xmark icon cursor-pointer" (click)="onRemoveSelectedRecord()"></i>
            </div>
        </div>
    </form>
    <ul class="mx-4 border border-gray-300 shadow-md select-none" *ngIf="isLoading">
        <li class="border-gray-300 h-10 flex items-center px-5 py-2.5 hover:bg-gray-200">
            <p>Cargando...</p>
        </li>
    </ul>
    <ul class="mx-4 border border-gray-300 shadow-md select-none" *ngIf="!isLoading && data.length == 0 && search.length > 0 && searched && !selected">
        <li class="border-gray-300 h-10 flex items-center px-5 py-2.5 hover:bg-gray-200">
            <p>No se encontraron coincidencias</p>
        </li>
    </ul>
    <ul class="mx-4 border border-gray-300 shadow-md select-none" *ngIf="!isLoading && data.length && !selected">
        <li *ngFor="let item of data" class="cursor-pointer border-gray-300 min-h-10 h-fit flex items-center px-5 py-2.5 hover:bg-gray-200" style="word-break: break-all;" (click)="onSelectedRecord(item)">
            <p>{{ item[displayNameProp] }}</p>
        </li>
    </ul>
</div>
